import { useQuery } from "@tanstack/react-query";

import { getRecentStudyLogs } from "@/api/stats";
import { useAuthStore } from "@/store/authStore";

const DAY_LABELS = ["일", "월", "화", "수", "목", "금", "토"] as const;

type WeeklyScore = { day: string; score: number };

/** 최근 7일 일별 점수 (차트용) */
export function useWeeklyScoresQuery() {
  const userId = useAuthStore(state => state.user?.id);

  return useQuery({
    queryKey: ["weeklyScores", userId],
    queryFn: () => getRecentStudyLogs(userId!, 7),
    enabled: Boolean(userId),
    select: (logs): WeeklyScore[] => {
      const today = new Date();
      const scoreMap = new Map(logs.map(log => [log.study_date, Math.round(log.exam_score ?? 0)]));

      return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(today);
        date.setDate(today.getDate() - 6 + i);
        const dateStr = date.toISOString().split("T")[0];
        return {
          day: DAY_LABELS[date.getDay()],
          score: scoreMap.get(dateStr) ?? 0,
        };
      });
    },
  });
}
